import React, { useState, useRef, useEffect } from "react";
import { useCreateSubDispositionMutation } from "../../../../Services/general/General";
import { toast } from "react-toastify";
import { Loader } from "react-bootstrap-typeahead";

interface IProps {
    closeModal: () => void;
    currentNode: { id: string; topic?: string };
    selectedTeam: any;
    refetch: () => void;
}

const AddSubMenuModal: React.FC<IProps> = ({
    closeModal,
    currentNode,
    selectedTeam,
    refetch,
}) => {
    const [topic, setTopic] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [trigger, { isLoading }] = useCreateSubDispositionMutation();
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        // Autofocus input on mount
        inputRef.current?.focus();
    }, []);

    const handleAdd = async () => {
        const trimmedTopic = topic.trim();
        if (!trimmedTopic) {
            toast.error("Topic cannot be empty.");
            return;
        }
        setIsSubmitting(true);
        const payload = {
            topic: trimmedTopic,
            priority: "low",
            ticket_name: null,
            team: selectedTeam,
            hide: false,
            tn_parent: currentNode?.id,
        };
        try {
            const response = await trigger({
                body: payload,
                id: selectedTeam,
            });
            if (response && response.data) {
                toast.success("Added successfully");
                refetch();
                setTopic(""); // Clear for re-use
                closeModal();
            } else {
                toast.error("Failed to add. Please try again.");
            }
        } catch (error: any) {
            toast.error(
                error?.data?.message || error?.message || "An error occurred."
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setTopic("");
        closeModal();
    };

    return (
        <div>
            <div className="mt-4">
                <input
                    ref={inputRef}
                    type="text"
                    className="form-control"
                    placeholder="Topic"
                    value={topic}
                    onChange={(e) => setTopic(e.target.value)}
                    disabled={isSubmitting || isLoading}
                    maxLength={100}
                    autoComplete="off"
                />
                <input type="hidden" value={currentNode?.topic} />
            </div>
            <div className="d-flex justify-content-end mt-4">
                <button
                    type="reset"
                    className="btn btn-sm btn-white text-hover-danger me-4"
                    onClick={handleClose}
                    disabled={isSubmitting || isLoading}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={handleAdd}
                    disabled={isSubmitting || isLoading || topic.trim().length < 1}
                >
                    {isLoading || isSubmitting ? (
                        <>
                            Adding... <Loader />
                        </>
                    ) : (
                        "Add"
                    )}
                </button>
            </div>
        </div>
    );
};

export default AddSubMenuModal;

